import { combineReducers } from 'redux';
import sessions from './sessions';
import registrations from './registrations';
import users from './users';
import teams from './teams';
import notifications from './notifications';
import invitations from './invitations';
import integrations from './integrations';

const rootReducer = combineReducers({
  sessions,
  registrations,
  users,
  teams,
  notifications,
  invitations,
  integrations
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js